import { useEffect, useState } from "react";
import { accountActions } from "../actions/account.actions";
import { accountService } from "../services/account.service";
import { user } from "../user";
import { useAppDispatch } from "./useAppDispatch";

/**
 * Restores the user session on a fresh load/reload.
 * Tokens are memory-only, so there is no in-memory session after a reload.
 * Attempts a silent refresh via the httpOnly cookie ("remember me").
 * Returns whether the bootstrap attempt is still in progress.
 */
export function useAutoLogin() {
    const dispatch = useAppDispatch();
    const [bootstrapping, setBootstrapping] = useState(true);

    useEffect(() => {
        let cancelled = false;

        async function bootstrapAuthentication() {
            if (!user.current()) {
                try {
                    const restored = await accountService.refreshToken();
                    if (restored && restored.accessToken) {
                        user.store(restored);
                    }
                } catch {
                    // No valid session cookie — stay anonymous, route guards send to login.
                }
            }

            if (cancelled) {
                return;
            }

            if (user.current()) {
                dispatch(accountActions.loginSuccess(user.current(), undefined, false));
            }

            setBootstrapping(false);
        }

        bootstrapAuthentication();

        return () => { cancelled = true; };
    }, [dispatch]);

    return bootstrapping;
}
